import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchTopPicks } from "../redux/topPicksSlice"; // adjust path if needed
import Skeleton from "react-loading-skeleton";
import { getListingUrl } from "../../../../utils/url.utils";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function TopPickSection() {
    const dispatch = useDispatch();

    const { items, status } = useSelector((state) => state.topPicks);

    useEffect(() => {
        if (status.topPicks === "idle") {
            dispatch(fetchTopPicks());
        }
    }, [dispatch, status.topPicks]);

    /* 🔄 Loading */
    if (status.topPicks === "loading") {
        return (
            <section className="top-picks-section web">
                <h2 className="top-picks-heading">Don’t miss these top picks.</h2>
                <div className="top-picks-grid">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="top-pick-card">
                            <Skeleton height={220} />
                            <Skeleton height={20} />
                        </div>
                    ))}
                </div>
            </section>
        );
    }

    /*  Empty */
    if (!items || items.length === 0) return null;

    return (
        <section className="top-picks-section web">
            <h2 className="top-picks-heading">Don’t miss these top picks.</h2>

            {/* Desktop */}
            <div className="desk-top-picks">
                <div className="top-picks-grid">
                    {items.map((item) => (
                        <div key={item.id} className="top-pick-card">
                            <Link to={getListingUrl(item.action_url)}>
                                <LazyLoadImage
                                    src={item.media}
                                    alt={item.name}
                                    className="top-pick-image pointer-crusser"
                                    effect="blur"
                                />
                                <p className="top-pick-title pointer-crusser">
                                    {item.name}
                                </p>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            {/* Mobile */}
            <div className="mlb-top-picks">
                <section className="flat_overview">
                    <div className="promo-section">
                        {items.map((item) => (
                            <div className="promo-card" key={item.id}>
                                <Link to={getListingUrl(item.action_url)}>
                                    <LazyLoadImage
                                        src={item.media}
                                        alt={item.name}
                                        className="promo-image pointer-crusser"
                                        effect="blur"
                                    />
                                    <p className="promo-title pointer-crusser">
                                        {item.name}
                                    </p>
                                </Link>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </section>

    );
}
